/**
 * Alarm Priority Formatter.
 * @param {*} value
 * @returns {*}
 */
window.alarmPriorityFormatter = function(value) {
    return '<i class="fa fa-circle" data-priority="'+value+'" aria-hidden="true"></i>';
};
